module.exports = __webpack_public_path__ + "static/media/20200810_131022.9e35a9c0.webp";